import { render, staticRenderFns } from "./MaterialDialog.vue?vue&type=template&id=88d6f2a6"
import script from "./MaterialDialog.vue?vue&type=script&lang=ts"
export * from "./MaterialDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports